import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styled from 'styled-components';
import image1 from '../Image/test1.jpg';
import image2 from '../Image/test2.jpg';
import image3 from '../Image/test3.jpg';
import image4 from '../Image/test2.jpg';
import image5 from '../Image/test1.jpg';

const Slide = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  background-color: transparent;
  padding-top: 3rem;
`;

const Image = styled.img`
  max-width: 97%;
  max-height: 97%;
`;

const MyCarousel = () => {
  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
        },
      },
    ],
  };

  return (
    <Slider {...settings}>
      <Slide>
        <Image src={image1} alt="Slide 1" />
      </Slide>
      <Slide>
        <Image src={image2} alt="Slide 2" />
      </Slide>
      <Slide>
        <Image src={image3} alt="Slide 3" />
      </Slide>
      <Slide>
        <Image src={image4} alt="Slide 4" />
      </Slide>
      <Slide>
        <Image src={image5} alt="Slide 5" />
      </Slide>
    </Slider>
  );
};

export default MyCarousel;
